'use client';

import { useMutation } from '@tanstack/react-query';
import { generateCustomVoicePreview } from '../actions/generateCustomVoicePreview';

/**
 * Generate a TTS preview for a custom (cloned) voice that doesn't have one.
 * Returns { previewUrl } on success.
 */
export function useCustomVoicePreviewMutation() {
  return useMutation({
    mutationFn: (voiceId: string) => generateCustomVoicePreview(voiceId),
  });
}
